import ButtonVariants from "@core-components/button/ButtonVariants";
import Icon from "@core-components/icon/Icon";
import EPublicRoutes from "@core-types/routes.enum";
import { useAppNavigate } from "@hooks/language/useAppNavigate";
import { Indicator } from "@mantine/core";
import { useBasketItems } from "@modules/order/stores/Basket.store";

const BasketButton: React.FC = () => {
  const basketItems = useBasketItems();
  const { navigate } = useAppNavigate();

  const basketBtn = (
    <ButtonVariants.ActionIcon onClick={() => navigate(EPublicRoutes.BASKET)}>
      <Icon.BasketShop />
    </ButtonVariants.ActionIcon>
  );

  if (basketItems.length === 0) {
    return basketBtn;
  }

  return (
    <Indicator
      processing
      classNames={{
        indicator: "p-2",
      }}
      hidden={true}
      label={basketItems.length}
      offset={5}
      position="bottom-start"
    >
      {basketBtn}
    </Indicator>
  );
};

export default BasketButton;
